import { styled, Box, Typography } from "@mui/material";
import { SadBrightbotIcon } from "../../../../../common/Icons/SadBrightbotIcon";

export const StyledContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "2.5rem .5rem",
}));

export const StyledSadBrightbotIcon = styled(SadBrightbotIcon)(() => ({
  fontSize: "5rem",
  marginBottom: ".5rem",
}));
